import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'sku-mappings',
    pluginName: 'SETTINGS',
    entityName: 'SKU_MAPPING',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

// Fetch SKU mappings action creators
export const fetchSKUMappingInit = () => {
    return crudActions.fetchInit();
};
export const fetchSKUMappingStart = () => {
    return crudActions.fetchStart();
};
export const fetchSKUMappingSuccess = (fetchSKUMappingCount, listSKUMappingCount) => {
    return crudActions.fetchSuccess(fetchSKUMappingCount, listSKUMappingCount);
};
export const fetchSKUMappingFail = () => {
    return crudActions.fetchFail();
};
export const fetchSKUMappingCount = (filterData) => {
    const rest = getAxiosInstance();
    return async (dispatch) => {
        dispatch(fetchSKUMappingStart());
        try {
            let countRes = await rest.post('sku-mappings/count', filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchSKUMappingSuccess(0, []));
                }
                return countRes.data.result.data;
            }
            dispatch(fetchSKUMappingFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : 'Cannot fetch SKU mappings.'}`,
                options: {
                    variant: 'warning',
                },
            });
            return 0;
        } catch (error) {
            dispatch(fetchSKUMappingFail());
            snackActions.snackBar({
                message: `${error.message || 'Cannot fetch SKU mappings.'}`,
                options: {
                    variant: 'error',
                },
            });
            return 0;
        }
    };
};

export const fetchSKUMapping = (filterData) => {
    const rest = getAxiosInstance();
    return async (dispatch) => {
        dispatch(fetchSKUMappingStart());
        try {
            let listRes = await rest.post('sku-mappings/list', filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchSKUMappingSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data;
            }
            dispatch(fetchSKUMappingFail());
            return [];
        } catch (error) {
            dispatch(fetchSKUMappingFail());
            return [];
        }
    };
};

// Load SKU mapping action creators
export const loadSKUMappingInit = () => {
    return crudActions.loadInit();
};
export const loadSKUMappingStart = () => {
    return crudActions.loadStart();
};
export const loadSKUMappingSuccess = (loadedSKUMapping) => {
    return crudActions.loadSuccess(loadedSKUMapping);
};
export const loadSKUMappingFail = (error) => {
    return crudActions.loadFail(error);
};
export const loadSKUMapping = (id) => {
    return async (dispatch) => {
        await crudActions.load(dispatch, id);
    };
};

export const createSKUMapping = (params) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/sku-mappings/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created SKU mapping.`,
                    options: {
                        variant: 'success',
                    },
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${
                    res && res.data ? res.data.message : res && res.message ? res.message : 'Cannot create SKU mapping.'
                }`,
                options: {
                    variant: 'warning',
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error',
                },
            });
            return null;
        }
    };
};

export const editSKUMapping = (params) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/sku-mappings/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated SKU mapping.`,
                    options: {
                        variant: 'success',
                    },
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${
                    res && res.data ? res.data.message : res && res.message ? res.message : 'Cannot edit SKU mapping.'
                }`,
                options: {
                    variant: 'warning',
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error',
                },
            });
            return null;
        }
    };
};

// Bulk delete SKU mappings action creators```
export const bulkDeleteSKUMappingsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteSKUMappingsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteSKUMappingsSuccess = (bulkDeleted) => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteSKUMappingsFail = (error) => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteSKUMappings = (params) => {
    const rest = getAxiosInstance();
    return async (dispatch) => {
        dispatch(bulkDeleteSKUMappingsStart());
        try {
            let res = await rest.post('/sku-mappings/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteSKUMappingsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted SKU mappings.`,
                    options: {
                        variant: 'success',
                    },
                });
                return;
            }
            dispatch(
                bulkDeleteSKUMappingsFail({
                    message: `${
                        res && res.data
                            ? res.data.message
                            : res && res.message
                            ? res.message
                            : 'Cannot bulk delete SKU mappings.'
                    }`,
                })
            );
            snackActions.snackBar({
                message: `${
                    res && res.data
                        ? res.data.message
                        : res && res.message
                        ? res.message
                        : 'Cannot bulk delete SKU mappings.'
                }`,
                options: {
                    variant: 'warning',
                },
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteSKUMappingsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error',
                },
            });
            return null;
        }
    };
};

export const uploadSKUMappingStart = () => {
    return {
        type: 'UPLOAD_SKU_MAPPING_START',
    };
};
export const uploadSKUMappingSuccess = () => {
    return {
        type: 'UPLOAD_SKU_MAPPING_SUCCESS',
    };
};
export const uploadSKUMappingFail = () => {
    return {
        type: 'UPLOAD_SKU_MAPPING_FAIL',
    };
};

export const uploadProgress = (data) => {
    return {
        type: 'SKU_MAPPING|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart,
    };
};

export const uploadSKUMappings = (data) => {
    const rest = getAxiosInstance();
    return async (dispatch) => {
        try {
            const config = {
                onUploadProgress: (progressEvent) => {
                    dispatch(
                        uploadProgress({
                            progress: Math.round((progressEvent.loaded * 100) / data.get('File').size),
                            loadSize: Math.round(progressEvent.loaded / 1048576),
                            maxSize: Math.round(progressEvent.total / 1048576),
                            snackStart: true,
                        })
                    );
                },
            };
            dispatch(uploadSKUMappingStart());
            let res = await rest.post('/sku-mappings/import', data, config);
            if (res.data.status === 200) {
                dispatch(uploadSKUMappingSuccess());
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success',
                    },
                });
                dispatch(uploadProgress({ progress: 100, loadSize: 0, maxSize: 0, snackStart: false }));

                return res.data.status === 200;
            } else {
                dispatch(uploadSKUMappingFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning',
                    },
                });
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }));

                return false;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }));
            dispatch(uploadSKUMappingFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error',
                },
            });
            return false;
        }
    };
};
